import type { UseFetchOptions } from "#app";

export default function useApi<T>(url: string | (() => string), opts: UseFetchOptions<T> = {}) {
  return useFetch(url, {
    ...opts,
    $fetch: useNuxtApp().$api
  })
}